import React, {
    useEffect, useState
} from "react"
import FileListSigner from "./FileListSigner"
import TextSigner from "./TextSigner"

const Signer = (props) => {
    const {
        values, // Объект содержащий поля, которые необходимо подписать
        setValuesSignatures,  // Объект для возврата подписей полей values в формате: `${key}Signature` - для строк, `${key}Signatures` - для списков файлов
        setIsSigning,// Стейт для запуска и прерывания лодинга
    } = props

    const [fileLists, setFileLists] = useState([]) // Хранит переданные списки файлов в формате [[key, [file1, file2, ...fileN]], ...]
    const [fileListSignatures, setFileListSignatures] = useState([])  // Хранит полученные списки подписей файлов в формате [[`${key}Signature`, signature], ...]
    const [textList, setTextList] = useState([]) // Хранит переданные строки в формате [[key, string], ...]

    const [fileSignerWorking, setFileSignerWorking] = useState(null) //Стейт для управления работой FileListSigner
    const [textSignerWorking, setTextSignerWorking] = useState(null) //Стейт для управления работой TextSigner

    const [fileSignerCurrentList, setFileSingerCurrentList] = useState([]) //Стейт для передачи списка файлов в FileListSigner
    const [fileSignerCurrentSignatureList, setFileSignerCurrentSignatureList] = useState([]) //Стейт для получения результатов работы FileListSigner
    const [textSignerCurrentList, setTextSingerCurrentList] = useState([]) //Стейт для передачи списка строк в TextSigner
    const [textSignerCurrentSignatureList, setTextSignerCurrentSignatureList] = useState([]) //Стейт для получения результатов работы TextSigner

    useEffect(() => {
        if(values){
            const valuesArray = Object.entries(values)
            const files = []
            const texts = []
		    valuesArray.map(([key, value]) => {
                if(value && value?.length){
                    if(Array.isArray(value)){
                        files.push([key, value])
                    }
                    if(typeof value === 'string'){
                        texts.push([key, value])
                    }
                }
            })
            setFileLists(files)
            setTextList(texts)
            setIsSigning(true)
            if(files.length){
                setFileSingerCurrentList(files[0][1]) // Кладем первый список файлов в переменную FileSinger
                setFileSignerWorking(true)  // Запускаем FileSinger
            }else if(texts.length){
                setTextSingerCurrentList(texts.map(([key, value]) => {return value})) // Кладем список строк в переменную TextSinger
                setTextSignerWorking(true) // Запускаем TextSinger
            }else{
                setTextSignerWorking(false) // ЗАВЕРШЕНИЕ РАБОТЫ
            }
        }
    }, [values])

    useEffect(() => {
        if(fileSignerWorking === false){ // Завершение цикла работы FileSinger
            const fileListSignaturesValues = [...fileListSignatures, [`${fileLists[fileListSignatures.length][0]}Signatures`, fileSignerCurrentSignatureList]]
            setFileListSignatures(fileListSignaturesValues) // Привожу к виду [[key, signature], ...]
            setFileSignerCurrentSignatureList([])
            if(fileLists?.length == fileListSignaturesValues?.length){
                if(textList.length){
                    setTextSignerCurrentSignatureList([])
                    setTextSingerCurrentList(textList.map(([key, value]) => {return value})) // Кладем список строк в переменную TextSinger
                    setTextSignerWorking(true) // Запускаем TextSinger
                } else {
                    setTextSignerCurrentSignatureList([])
                    setTextSignerWorking(false) // ЗАВЕРШЕНИЕ РАБОТЫ
                }
            }else if(fileLists?.length > fileListSignaturesValues?.length){
                setFileSingerCurrentList(fileLists[fileListSignaturesValues?.length][1])
                setFileSignerWorking(true)  // Запускаем FileSinger
            }
        }
    }, [fileSignerWorking])

    useEffect(() => {
        if(textSignerWorking === false){ // Завершение цикла работы TextSinger
            let textResultValues = {}
            if (textSignerCurrentSignatureList.length){ // результат подписания всех строк хранится в списке textSignerCurrentSignatureList
                const keySinatureArray = textList.map(([key, value], index) => { // Привожу к виду [[key, signature], ...]
                    return [`${key}Signature`, textSignerCurrentSignatureList[index]]
                })
                textResultValues = Object.fromEntries(keySinatureArray)
            }
            let fileResultValues = {}
            if(fileListSignatures.length){
                fileResultValues =  Object.fromEntries(fileListSignatures)
            }
            setValuesSignatures({...fileResultValues, ...textResultValues})
            clearSignerStates()
        }
    }, [textSignerWorking])

    function clearSignerStates(){
        setFileLists([])
        setFileListSignatures([]) 
        setTextList([])
        
        setTextSignerWorking(null)
        setFileSingerCurrentList([]) 
        setTextSingerCurrentList([]) 
        setTextSignerCurrentSignatureList([])
    }

    return( <>
                <FileListSigner 
                    fileSignerWorkingState={fileSignerWorking} 
                    setFileSignerWorkingState={setFileSignerWorking}
                    filesState={fileSignerCurrentList}
                    fileSignaturesState={fileSignerCurrentSignatureList}
                    setFileSignaturesState={setFileSignerCurrentSignatureList}
                    setIsSigning={setIsSigning} 
                />
                <TextSigner
                    textSignerWorkingState={textSignerWorking}
                    setTextSignerWorkingState={setTextSignerWorking}
                    textListToSign={textSignerCurrentList}
                    textSignaturesList={textSignerCurrentSignatureList}
                    setTextSignaturesList={setTextSignerCurrentSignatureList}
                    setIsSigning={setIsSigning}
                />
            </>)
}
export default Signer
